module.exports = __webpack_public_path__ + "static/media/icon_schedule_film.0bd600f3.svg";